import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'emerald-ui';
import SignUpFormAddress from '../SignUpFormAddress';

class SignUpFormPrimaryAddress extends Component {
  render() {
    const {
      streetAddress = {},
      houseNumber = {},
      country = {},
      city = {},
      state = {},
      zipCode = {},
      isAddressOutsideUS,
    } = this.props;

    return (
      <Row>
        <Col xs={12} md={5}>
          <div className="sign-up-form-description">
            <p>Primary address</p>
            <p>Enter your primary physical address</p>
          </div>
        </Col>
        <Col xs={12} md={7}>
          <SignUpFormAddress
            handleFieldChange={this.props.handleFieldChange}
            streetAddress={streetAddress}
            houseNumber={houseNumber}
            country={country}
            city={city}
            state={state}
            zipCode={zipCode}
            isAddressOutsideUS={isAddressOutsideUS}
          />
        </Col>
      </Row>
    );
  }
}

SignUpFormPrimaryAddress.propTypes = {
  handleFieldChange: PropTypes.func,
};

SignUpFormPrimaryAddress.defaultProps = {
  handleFieldChange: () => {},
};

export default SignUpFormPrimaryAddress;



// WEBPACK FOOTER //
// ./src/components/SignUpFormPrimaryAddress/SignUpFormPrimaryAddress.js